import React from 'react';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="bg-brand-navydeep px-4 py-14 text-center text-sm text-white/55" data-id="element-69" data-mp="32p5nojgp12qd">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="36qhgsyys063b">
        <p className="font-display text-xl font-semibold uppercase tracking-[0.22em] text-white" data-id="element-71" data-mp="36nd6djupwe47">
          Arte Lista
        </p>
        <p className="mt-3 text-xs text-white/50" data-id="element-72" data-mp="38h3r5ed5aiu">
          El recurso definitivo para docentes de Arte de Argentina.
        </p>
        <nav aria-label="Enlaces legales" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-xs" data-id="element-73" data-mp="3ldap3k9vobm0">
          {links.map(link => <a key={link.label} href={link.href} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-74" data-mp="29y5fdwbbxcsw">
              {link.label}
            </a>)}
        </nav>
        <p className="text-xs text-white/40" data-id="element-75" data-mp="3lbmvrwv0jgi0">
          © 2027 ARTE LISTA — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}